/** Пагинация admin-списков: одинаковая у мерчантов, команд и трейдеров. */
export interface ListParams {
    limit?: number;
    offset?: number;
}

/** Общий хвост `?limit=&offset=` — чтобы каждый список не собирал его заново. */
export function listQuerySuffix(query: ListParams): string {
    const params = new URLSearchParams();
    if (query.limit != null) params.set("limit", String(query.limit));
    if (query.offset != null) params.set("offset", String(query.offset));
    const suffix = params.toString();
    return suffix ? `?${suffix}` : "";
}
